import Vue from 'vue';
import App from './App.vue';


import Init from '@/helpers/Init';
import { store } from '@/store/store';
import { router } from '@/routes';

Vue.config.productionTip = false;

//initialise GTM
Init();

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#vueApp');
